import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const SessionModalDefaultProps = {
  ...ClassNameDefaultProps,
  isOpen: false,
  onActionClick: () => null,
};

export const SessionModalPropTypes = {
  ...ClassNamePropTypes,
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool,
  onActionClick: PropTypes.func,
};
